import { fs138AVSverificationPlans } from "../firestore_schemas/fs138AVSverificationPlans"
import { addDocIn_fs138AVSverificationPlans } from "../firestore_schemas/fs138AVSverificationPlans"
import { getDocFrom_fs138AVSverificationPlans } from "../firestore_schemas/fs138AVSverificationPlans"
import { setDocIn_fs138AVSverificationPlans } from "../firestore_schemas/fs138AVSverificationPlans"
import { removeDocFrom_fs138AVSverificationPlans } from "../firestore_schemas/fs138AVSverificationPlans"
import { setValueOfOptionalFields } from "../firestore_writers/include/general"

type Result = {
  debug_data: Array<string>;
  return_msg: string;
  success: boolean;
  error_title: string;
  error_summary: string;
  error_next_steps: string;
};

export async function fs138Writer(
  w_type: string,
  fs1_id: string,
  fs2_id: string,
  fs138_id: string,
  data: any
) {

  const retval: Result = {
    debug_data: [],
    return_msg: "fs138_writer:fs138Writer ",
    success: true,
    error_title: "",
    error_summary: "",
    error_next_steps: "",
  };

  /// Validate arguments according to write type
  if (!fs1_id || !fs2_id || !fs138_id) {
    retval.success = false;
    retval.return_msg += "Insufficient arguments.";
    retval.error_title = "Insufficient arguments.";
    retval.error_summary = "business_uid or recycler_uid not set.";
    retval.error_next_steps = "Please provide correct business_uid snd recycler_uid.";
    return retval;
  }

  /// <END> Validate arguments according to write type

  // Delete record
  if (w_type == "d") {
    await removeDocFrom_fs138AVSverificationPlans(fs1_id, fs2_id, fs138_id)
    return retval
  }

  // Update existing record
  if (w_type == "e") {
    let response_data = await getDocFrom_fs138AVSverificationPlans(
      fs1_id,
      fs2_id,
      fs138_id,
    )

    if (response_data.success === false) {
      retval.success = false;
      retval.return_msg += "Record not found.";
      retval.error_title = "Record not found.";
      retval.error_summary = "FS138 record not found in firestore.";
      retval.error_next_steps = "Please reload page and try again.";
      return retval;
    }
    const fs138Data: fs138AVSverificationPlans = {
      avs_verification_type: data.avs_verification_type || response_data['doc_data'].avs_verification_type || "",
    } as fs138AVSverificationPlans;

    let response = await setDocIn_fs138AVSverificationPlans(
      fs1_id,
      fs2_id,
      fs138_id,
      fs138Data
    )

    if (!response.id || response.id == "" ) {
      retval.success = false;
      retval.return_msg += "Firestore write error.";
      retval.error_title = "Firestore write error.";
      retval.error_summary = "FS138 record not updated in firestore.";
      retval.error_next_steps = "Please reload page and try again.";
      return retval;
    }

    return retval
  }

  
  if (w_type === "n") {
    const fs138Data: fs138AVSverificationPlans = {
      avs_verification_type: data.avs_verification_type || ""
    } as fs138AVSverificationPlans;

    let response = await addDocIn_fs138AVSverificationPlans(
      fs1_id,
      fs2_id,
      fs138_id,
      fs138Data
    )
    if (!response.id || response.id == "" ) {
      retval.success = false;
      retval.return_msg += "Firestore write error.";
      retval.error_title = "Firestore write error.";
      retval.error_summary = "FS138 record not created in firestore.";
      retval.error_next_steps = "Please reload page and try again.";
      return retval;
    }

    return retval
  }
  // TODO - handle new operations
}


function firestoreWriteError(error:any) {
  // TODO - complete this
}
